import React, {memo} from 'react';
import {Collapse, useDisclosure} from '@chakra-ui/react';
import {useBoolBag} from '~/hooks';
import {UiBox, UiButton, UiFormControl} from '.';

interface Props {
  children: React.ReactNode;
}

export const UiFilter = memo(function AppFilter({children}: Props) {
  const {boolBag, setBoolBag} = useBoolBag({});
  const {showFilter} = boolBag;
  const {isOpen, onToggle} = useDisclosure();

  return (
    <>
      <UiButton onClick={onToggle}>Advanced Filters</UiButton>
      <Collapse in={isOpen} animateOpacity>
        <UiBox p="40px" color="white" mt="2" rounded="md" shadow="md">
          <UiFormControl>{children}</UiFormControl>
        </UiBox>
      </Collapse>
    </>
  );
});
